export default __webpack_public_path__ + "static/media/address.2bf36e73.png";